import "./style.scss";
import { Collapse } from "antd";
import { SelectArrow } from "assets/icons";

function Accordion({ data, accordionClassName, defaultActiveKey = ["0"] }) {
  return (
    <Collapse
      className={`accordion-section ${accordionClassName}`}
      defaultActiveKey={defaultActiveKey}
      ghost
      items={data}
      expandIconPosition="end"
      expandIcon={({ isActive }) => (
        <SelectArrow
          style={{
            transform: isActive ? "rotate(180deg)" : "rotate(266deg)",
            transition: "0.3s",
          }}
        />
      )}
    />
  );
}

export default Accordion;
